import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import TableList from '../../components/TableList';
import { ContextMenu } from '../../components/context-menu/context-menu';
import { MessengerBox } from '../../components/messenger-box/messenger-box';
import { AppSettings } from '../../constants';
import {
  initialSizePerPage,
  dispatchActionSetPageSizeReference
} from 'helper/unit-helper';
import * as PunchListActionType from '../constants';
import * as RFSActionType from 'Request-Services/constants';
import * as AuthActionType from 'Auth/constants';
import * as ProjectActionType from 'Projects/constants';
import * as BuilderActionType from 'Builders/constants';
import Translate from 'components/translate';
import BuilderPunchListFilter from '../Components/BuilderPunchListFilter';
import SubcontractorPunchListFilter from '../Components/SubcontractorPunchListFilter';
import { ExportButton } from 'Work-Orders/Components/ExportButton';
import { ChangeColumn } from 'components/change-column';

const defaultParams = {
  defaultSortName: 'refNo',
  defaultSortOrder: 'descending',
  sizePerPage: 10
};

const TABLE_NAME = 'PUNCH_LIST_LIST';

class ManagePunchLists extends Component {
  static propTypes = {
    history: PropTypes.object,
    dispatch: PropTypes.func,
    PunchListStore: PropTypes.object,
    SelectListRegions: PropTypes.array,
    SelectListMarkets: PropTypes.array,
    SelectListProjects: PropTypes.array,
    builderUserList: PropTypes.array,
    SelectListRequestType: PropTypes.array,
    UserProfile: PropTypes.object,
    SelectListLots: PropTypes.array,
    SubcontractorSelectListProjects: PropTypes.array,
    PageSizeReference: PropTypes.object,
    SettingDataGridColumn: PropTypes.object,
    location: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.sizePerPage = initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.PunchListStore.ManagePunchList.params.take
    );

    this.subcontractorColumns = [
      {
        field: 'refNo',
        header: 'PL#',
        hidden: false,
        isKey: true,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderPunchListRefNo.bind(this),
        widthStyle: 'number'
      },
      {
        field: 'createdDate',
        header: 'Created',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderDate.bind(this, 'createdDate'),
        widthStyle: 'name'
      },
      {
        field: 'projectName',
        header: <Translate translateKey='project' capitalize />,
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        widthStyle: 'name',
        customRender: this.customRenderSubcontractorProjectName.bind(this)
      },
      {
        field: 'lotName',
        header: (
          <span>
            <Translate translateKey='lot' capitalize /> #
          </span>
        ),
        isKey: false,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left',
        widthStyle: 'name',
        customRender: this.customRenderSubcontractorLotName.bind(this)
      },
      {
        field: 'streetAddress',
        header: 'Street address',
        isKey: false,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left',
        width: '350px',
        customRender: this.customRenderSubcontractorLotStreetAddress.bind(this)
      },
      {
        field: 'requestTypeName',
        header: 'Request type',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        widthStyle: 'name',
        customRender: this.customRenderSubcontractorRequestType.bind(this)
      },
      {
        field: 'managedByUserName',
        header: 'Managed by',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left',
        widthStyle: 'name',
        customRender: this.customRenderSubcontractorManagedByUserName.bind(this)
      },
      {
        field: 'statusValue',
        header: 'Status',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left',
        widthStyle: 'name'
      }
    ];

    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      currentPage: props.PunchListStore.ManagePunchList.params.skip,
      sizePerPage: this.sizePerPage,
      totalRecord: props.PunchListStore.ManagePunchList.params.totalRecord,
      data: props.PunchListStore.ManagePunchList.items,
      status: props.PunchListStore.ManagePunchList.params.status,
      settingColumn: [],
      isDisplayTable: true,
      builderColumns: [
        {
          field: 'refNo',
          header: 'BT#',
          hidden: false,
          isKey: true,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          customRender: this.customRenderPunchListRefNo.bind(this),
          widthStyle: 'number'
        },
        {
          field: 'originalRefNo',
          header: 'Legacy ID (v3)',
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          customRender: this.customRenderOriginalRefNoV3.bind(this),
          widthStyle: 'legacy'
        },
        {
          field: 'createdDate',
          header: 'Created',
          hidden: false,
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          customRender: this.customRenderDate.bind(this, 'createdDate'),
          widthStyle: 'name'
        },
        {
          field: 'projectName',
          header: <Translate translateKey='project' capitalize />,
          hidden: false,
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name',
          customRender: this.customRenderProjectName.bind(this)
        },
        {
          field: 'lotName',
          header: (
            <span>
              <Translate translateKey='lot' capitalize /> #
            </span>
          ),
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name'
        },
        {
          field: 'streetAddress',
          header: 'Street address',
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          width: '350px'
        },
        {
          field: 'requestTypeName',
          header: 'Request type',
          hidden: false,
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name'
        },
        {
          field: 'managedByUserName',
          header: 'Managed by',
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name'
        },
        {
          field: 'statusValue',
          header: 'Status',
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name'
        },
        {
          field: 'numberOfWOs',
          header: '# of WOs',
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'number'
        },
        {
          field: 'numberOfOpenWOs',
          header: '# of open WOs',
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: 'left',
          headerAlign: 'left',
          widthStyle: 'name'
        },
        {
          field: 'eplFinalAcceptedDate',
          header: 'Final Accepted Date',
          hidden: false,
          isKey: false,
          sort: true,
          dataAlign: 'left',
          headerAlign: 'left',
          width: '170px',
          customRender: this.customRenderDate.bind(this, 'eplFinalAcceptedDate')
        },
        {
          field: '',
          header: '',
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: 'right',
          headerAlign: 'right',
          customRender: this.customRenderBtnAction.bind(this),
          className: 'column-action',
          columnClassName: 'column-action',
          widthStyle: 'name'
        }
      ]
    };
  }

  componentDidMount() {
    console.log('manage-punch-lists',{...this.props.PunchListStore.ManagePunchList.params},this.state.sizePerPage);
    this.binding(
      this.objToParams({
        ...this.props.PunchListStore.ManagePunchList.params,
        take: this.state.sizePerPage
      })
    );

    if (
      this.props.UserProfile &&
      this.props.UserProfile.userId &&
      this.props.SettingDataGridColumn
    ) {
      this.setDefaultColumn(
        this.props.UserProfile.userId,
        this.props.SettingDataGridColumn
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const { ManagePunchList } = nextProps.PunchListStore;
    if (ManagePunchList) {
      this.setState({
        totalRecord: ManagePunchList.params.totalRecord,
        data: ManagePunchList.items,
        status: ManagePunchList.params.status,
        currentPage: ManagePunchList.params.skip
      });
    }

    if (
      nextProps.UserProfile &&
      nextProps.UserProfile.userId &&
      nextProps.SettingDataGridColumn
    ) {
      this.setDefaultColumn(
        nextProps.UserProfile.userId,
        nextProps.SettingDataGridColumn
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: PunchListActionType.RESET_PUNCH_LIST });
  }

  customRenderPunchListRefNo = item => {
    return <Link to={`/punch-lists/${item.refNo}`}>{item.refNo}</Link>;
  };

  customRenderOriginalRefNoV3 = item => {
    if (item.originalRefNo !== null) {
      return (<span>{item.originalRefNo}</span>);
    }
    return '-';
  }

  customRenderCreatedDate = item => {
    return <span>{Moment(item.createdDate).format('MM/DD/YYYY')}</span>;
  };

  customRenderDate = (fieldName, item) => {
    return <span>{Moment(item[fieldName]).format('MM/DD/YYYY')}</span>;
  };

  customRenderBtnAction(item) {
    return (
      <a
        className='glyphicon glyphicon-option-vertical cls-table-black-icon'
        onClick={e => {
          this.onContextMenu(e, item);
        }}
      />
    );
  }

  customRenderSubcontractorProjectName(item) {
    return <span>{item.project.name}</span>;
  }

  customRenderSubcontractorLotName(item) {
    return <span>{item.lot.name}</span>;
  }

  customRenderSubcontractorLotStreetAddress(item) {
    return <span>{item.lot.streetAddress}</span>;
  }

  customRenderSubcontractorRequestType(item) {
    return <span>{item.requestType.name}</span>;
  }

  customRenderSubcontractorManagedByUserName(item) {
    return <span>{item.managedByUser.displayName}</span>;
  }

  onContextMenu(e, item) {
    var contextItem = [
      {
        title: 'View detail',
        icon: '',
        event: this.onViewDetail.bind(this)
      },
      {
        title: 'Add new work order',
        icon: '',
        event: this.onAddNewWorkOrder.bind(this)
      }
    ];

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onViewDetail(e, item) {
    e.preventDefault();
    this.props.history.push(`/punch-lists/${item.refNo}`);
  }

  onAddNewWorkOrder(e, item) {
    e.preventDefault();
    this.props.history.push(`/punch-lists/${item.refNo}/add`);
  }

  onFetchRegion = (params) => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_REGION_ASYNC,
      params: {
        ProjectIds: params.projectId,
        MarketIds: params.marketId,
        LotIds: params.lotId
      }
    });
  };

  onFetchMarket = (params) => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_MARKET_ASYNC,
      params: {
        ProjectIds: params.projectId,
        RegionIds: params.regionId,
        LotIds: params.lotId
      }
    });
  };

  onFetchLot = (params) => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_LOT_ASYNC,
      params: {
        ProjectIds: params.projectId,
        RegionIds: params.regionId,
        MarketIds: params.marketId
      }
    });
  };

  onFetchProject = (params) => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_PROJECT_ASYNC,
      params: {
        RegionIds: params.regionId,
        MarketIds: params.marketId,
        LotIds: params.lotId
      }
    });
  };

  onFetchRFSManagedBy = () => {
    this.props.dispatch({
      type: AuthActionType.SELECT_LISTS_BUILDER_USER_ASYNC,
      params: {
        searchKey: '',
        selectedValue: ''
      }
    });
  };

  onFetchRequestType = () => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_REQUEST_TYPE_ASYNC,
      params: { searchKey: '' }
    });
  };

  onSearchRFS = params => {
    this.setState(
      {
        paramFilter: params
      },
      () => {
        this.onSearch();
      }
    );
  };

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onSearch(e);
    }
  }

  onSearch() {
    var paramSearch = this.objToParams(
      this.props.PunchListStore.ManagePunchList.params
    );

    const params = Object.assign({}, paramSearch, this.state.paramFilter);

    this.binding({
      ...params,
      skip: 0
    });
  }

  onSearchProject = params => {
    this.setState(
      {
        paramFilter: params
      },
      () => {
        this.onSearch();
      }
    );
  };

  onTableBinding(configTable) {
    this.binding({
      ...this.objToParams(this.props.PunchListStore.ManagePunchList.params),
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });
  }

  binding(params) {
    if (AppSettings.clientTypeValue === 'Builder') {
      this.props.dispatch({
        type: PunchListActionType.SEARCH_PUNCH_LIST_ASYNC,
        params: params
      });
    }

    if (AppSettings.clientTypeValue === 'Subcontractor') {
      this.props.dispatch({
        type: PunchListActionType.SEARCH_SUBCONTRACTOR_PUNCH_LIST_ASYNC,
        params: params
      });
    }
  }

  objToParams(obj) {
    return {
      searchKey: this.search.value.trim(),
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        if (AppSettings.clientTypeValue === 'Builder') {
          this.props.dispatch({
            type: PunchListActionType.SEARCH_PUNCH_LIST_ASYNC,
            params: {
              searchKey: this.search.value.trim(),
              sortField: params.defaultSortName,
              sortOrder: params.defaultSortOrder,
              skip: params.currentPage - 1,
              take: params.sizePerPage,
              ...this.state.paramFilter
            }
          });
        }

        if (AppSettings.clientTypeValue === 'Subcontractor') {
          this.props.dispatch({
            type: PunchListActionType.SEARCH_SUBCONTRACTOR_PUNCH_LIST_ASYNC,
            params: {
              searchKey: this.search.value.trim(),
              sortField: params.defaultSortName,
              sortOrder: params.defaultSortOrder,
              skip: params.currentPage - 1,
              take: params.sizePerPage,
              ...this.state.paramFilter
            }
          });
        }
      }
    );
  }

  toolTip(message) {
    return (
      <Tooltip
        className='in tooltip-siteone'
        placement='top'
        id='tooltip'
        positionLeft={0}
        arrowOffsetLeft={0}
      >
        <span
          style={{
            wordBreak: 'break-all',
            maxWidth: 200
          }}
        >
          {message}
        </span>
      </Tooltip>
    );
  }

  customRenderProjectName(item) {
    return (
      <OverlayTrigger
        placement='top'
        overlay={this.toolTip(item.projectName)}
        delayHide={10}
        delayShow={500}
      >
        <div
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          }}
        >
          {item.projectName}
        </div>
      </OverlayTrigger>
    );
  }

  handleExport = () => {
    const {
      PunchListStore: {
        ManagePunchList: { params }
      }
    } = this.props;

    this.props.dispatch({
      type: PunchListActionType.EXPORT_PUNCH_LIST_LIST,
      params: {
        ...this.objToParams({
          ...params,
          skip: 1,
          take: ''
        }),
        timeZoneOffset: -(new Date()).getTimezoneOffset(),
        ...this.state.paramFilter
      }
    });
  };

  onFetchSubcontractorProjectSelectList = callback => {
    this.props.dispatch({
      type: ProjectActionType.SELECT_SUBCONTRACTOR_LIST_PROJECT_ASYNC,
      params: {
        param: { searchKey: '', selectedValue: '' }
      },
      callback
    });
  };

  onChangeColumn = (newColumn, selectedColumnField) => {
    this.setState({ isDisplayTable: false }, () => {
      this.props.dispatch({
        type: BuilderActionType.SET_SELECT_COLUMN,
        params: {
          id: this.props.UserProfile.userId,
          type: 'PL_COLUMN',
          data: selectedColumnField
        }
      });

      setTimeout(() => {
        this.setState({ isDisplayTable: true });
      }, 200);
    });
  }

  setDefaultColumn = (userId, settingDataGridColumnProps) => {
    if (
      settingDataGridColumnProps.hasOwnProperty(userId) &&
      settingDataGridColumnProps[userId].hasOwnProperty('PL_COLUMN')
    ) {
      const selectedColumnFields =
        settingDataGridColumnProps[userId].PL_COLUMN;
      this.setState({ settingColumn: selectedColumnFields });
      const newColumnState = [...this.state.builderColumns];
      newColumnState.map(column => {
        if (column.field !== '') {
          if (selectedColumnFields.indexOf(column.field) !== -1) {
            column.hidden = false;
          } else {
            column.hidden = true;
          }
        }
      });
      this.setState({ builderColumns: newColumnState });
    }
  };

  renderPunchListFilter = () => {
    if (AppSettings.clientTypeValue === 'Builder') {
      return (
        <BuilderPunchListFilter
          onFetchRegion={this.onFetchRegion}
          RegionSelectList={this.props.SelectListRegions}
          onFetchMarket={this.onFetchMarket}
          MarketSelectList={this.props.SelectListMarkets}
          onFetchProject={this.onFetchProject}
          ProjectSelectList={this.props.SelectListProjects}
          onFetchRFSManagedBy={this.onFetchRFSManagedBy}
          RFSManagedBySelectList={this.props.builderUserList}
          onSearchRFS={this.onSearchRFS}
          onFetchRequestType={this.onFetchRequestType}
          RequestTypeSelectList={this.props.SelectListRequestType}
          onFetchLot={this.onFetchLot}
          LotSelectList={this.props.SelectListLots}
          sso={this.props.UserProfile.sso}
          location={this.props.location}
        />
      );
    } else {
      return (
        <SubcontractorPunchListFilter
          onFetchProject={this.onFetchSubcontractorProjectSelectList}
          ProjectSelectList={this.props.SubcontractorSelectListProjects}
          onSearchRFS={this.onSearchRFS}
          sso={this.props.UserProfile.sso}
        />
      );
    }
  };

  render() {
    let column = [];

    if (AppSettings.clientTypeValue === 'Subcontractor') {
      column = this.subcontractorColumns;
    } else {
      column = this.state.builderColumns;
    }

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: this.state.totalRecord
    };

    const {settingColumn, isDisplayTable} = this.state;

    const tableHeader = (
      <div className='table-header'>
        <Row>
          <Col
            sm={12}
            md={12}
            className='text-right table-header-change-column'
          >
            {AppSettings.clientTypeValue === 'Builder' && (
              <ChangeColumn
                columnList={column}
                settingColumn={settingColumn}
                onChangeColumn={this.onChangeColumn}
              />
            )}
            {AppSettings.clientTypeValue === 'Builder' && (
              <ExportButton onClick={this.handleExport} />
            )}
            <div className='box-search' style={{ margin: 0 }}>
              <div className='input-group'>
                <input
                  type='text'
                  id='txt-search-email'
                  ref={ref => {
                    this.search = ref;
                  }}
                  className='form-control'
                  placeholder= {AppSettings.clientTypeValue === 'Builder' ? 'BT#' : 'PL#'}
                  onKeyPress={this.onEnter.bind(this)}
                />
                <span className='input-group-btn'>
                  <button
                    onClick={this.onSearch.bind(this)}
                    className='btn btn-secondary'
                  >
                    <span className='fa fa-search' aria-hidden='true' />
                  </button>
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id='manage-user'>
        <div className='page-title clearfix'>
          <h2 className='pull-left'>{AppSettings.clientTypeValue === 'Builder' ? 
          'Blue Tapes' 
          // <Translate translateKey='punchlist' capitalize />
          : 'Punch list'} ({this.state.totalRecord})</h2>
          {AppSettings.clientTypeValue === 'Builder' && (
            <Link
              className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
              to={'/punch-lists/add'}
            >
              <span className='fa fa-plus icon' />
              NEW
            </Link>
          )}
        </div>

        {this.renderPunchListFilter()}

        <TableList
          column={column}
          defaultParams={defaultParams}
          data={this.state.data}
          options={options}
          refreshPageList={this.refreshList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          showButtonMenu={true}
          onContextMenu={this.onContextMenu.bind(this)}
          customTableHeader={tableHeader}
          isDisplayTable={isDisplayTable}
        />

        <ContextMenu
          ref={ref => {
            this.cxtMenu = ref;
          }}
        />
        <MessengerBox
          ref={ref => {
            this.msgBox = ref;
          }}
          title={AppSettings.COMPANY_NAME}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    PunchListStore: state.PunchListStore,
    SelectListRegions: state.RFSStore.SelectListRegions,
    SelectListMarkets: state.RFSStore.SelectListMarkets,
    SelectListProjects: state.RFSStore.SelectListProjects,
    SubcontractorSelectListProjects: state.ProjectStore.ProjectList,
    builderUserList: state.authReducer.builderUserList,
    UserProfile: state.UserStore.UserProfile,
    SelectListRequestType: state.RFSStore.SelectListRequestType,
    SelectListLots: state.RFSStore.SelectListLots,
    PageSizeReference: state.BuilderStore.PageSizeReference,
    SettingDataGridColumn: state.BuilderStore.SettingDataGridColumn
  };
};

export default connect(mapStateToProps)(ManagePunchLists);



// WEBPACK FOOTER //
// ./src/Punch-List/Containers/manage-punch-list.js